
    const data = {"name":"src/core/icons/login","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M10 17v-3H3v-4h7V7l5 5-5 5m0-15h9a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-2h2v2h9V4h-9v2H8V4a2 2 0 0 1 2-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            